"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttackRange = exports.getStats = void 0;
const getDefinition = (piece, creatures) => {
    const definition = creatures.get(piece.definitionId);
    if (!definition) {
        throw new Error(`Unknown definitionId: ${piece.definitionId}`);
    }
    return definition;
};
const getStats = (piece, creatures) => getDefinition(piece, creatures).stages[piece.stage];
exports.getStats = getStats;
const getAttackRange = (piece, creatures) => getDefinition(piece, creatures).attackRange;
exports.getAttackRange = getAttackRange;
